import { SxProps, Theme } from '@mui/material';

interface Styles {
  container: SxProps<Theme>;
  paper: SxProps<Theme>;
  header: SxProps<Theme>;
  icon: SxProps<Theme>;
  title: SxProps<Theme>;
  subtitle: SxProps<Theme>;
  form: SxProps<Theme>;
  error: SxProps<Theme>;
  submitButton: SxProps<Theme>;
}

export const styles: Styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    p: 2,
    width: '100%',
  },
  paper: {
    p: 4,
    maxWidth: 500,
    width: '100%',
    m: 2,
    backgroundColor: (theme) => theme.palette.background.paper,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    mb: 2,
  },
  icon: {
    mr: 1,
    color: 'primary.main',
    fontSize: 30,
  },
  title: {
    fontWeight: 600,
  },
  subtitle: {
    color: 'text.secondary',
    mb: 3,
  },
  form: {
    mt: 2,
  },
  error: {
    mt: 2,
  },
  submitButton: {
    mt: 3,
    mb: 2,
    py: 1,
  },
};